import { Mapper } from "../../../../lib/utils/mapper";
import { ProductsRemoteDataSource } from "../datasources/products-remote.datasource";
import type { IProductsRemoteDatasource } from "../datasources/products-remote.datasource.interface";
import { ProductLean } from "../entities/product-lean/product-lean.entity";
import { ProductsAvailabilities } from "../entities/products-availabilities.entity";
import type { IProductsRepository } from "./products.repository.interface";

export class ProductsRepository implements IProductsRepository {
  constructor(private readonly _productsRemoteDataSource: IProductsRemoteDatasource = new ProductsRemoteDataSource()) {}

  async getAllProductsLeanWithAvailability(citizenId: number, timestamp: number): Promise<ProductsAvailabilities> {
    const availabilitiesProductsDto = await this._productsRemoteDataSource.getAllProductsLean(citizenId, timestamp);

    const productAvailableCollection = Mapper.mapArrayData(ProductLean, availabilitiesProductsDto.available);
    const productNotAvailableCollection = Mapper.mapArrayData(ProductLean, availabilitiesProductsDto.notAvailable);

    const productsAvailabilities = new ProductsAvailabilities(
      productAvailableCollection,
      productNotAvailableCollection
    );
    return productsAvailabilities;
  }

  async getProductsLeanByUniqueIdentifiers(
    citizenId: number,
    timestamp: number,
    uniqueIdentifiers: string[]
  ): Promise<ProductsAvailabilities> {
    const availabilitiesProductsDto = await this._productsRemoteDataSource.getAllProductsLean(citizenId, timestamp);

    const productAvailableCollection: ProductLean[] = [];
    const productNotAvailableCollection: ProductLean[] = [];

    for (const product of availabilitiesProductsDto.available) {
      if (uniqueIdentifiers.includes(product.uniqueIdentifier)) {
        const productLeanEntity = Mapper.mapData(ProductLean, product);
        productAvailableCollection.push(productLeanEntity);
      }
    }

    for (const product of availabilitiesProductsDto.notAvailable) {
      if (uniqueIdentifiers.includes(product.uniqueIdentifier)) {
        const productLeanEntity = Mapper.mapData(ProductLean, product);
        productNotAvailableCollection.push(productLeanEntity);
      }
    }

    const productsAvailabilities = new ProductsAvailabilities(
      productAvailableCollection,
      productNotAvailableCollection
    );
    return productsAvailabilities;
  }
}
